export default __webpack_public_path__ + "static/media/logo.abc85278.svg";